import { useQuery } from '@tanstack/react-query';
import { seekSupabase } from '@/integrations/supabase/seekClient';

export function useSeekApplicationTimeline(seekApplicationId: string | null) {
  const query = useQuery({
    queryKey: ['seek-application-timeline', seekApplicationId],
    queryFn: async () => {
      const { data, error } = await seekSupabase
        .from('application_status_events')
        .select('*')
        .eq('seek_application_id', seekApplicationId!)
        .order('occurred_at', { ascending: false });
      if (error) throw error;
      return data ?? [];
    },
    enabled: !!seekApplicationId,
  });

  return {
    events: query.data ?? [],
    isLoading: query.isLoading,
  };
}
